import { render, staticRenderFns } from "./save-paper-info.html?vue&type=template&id=80f43d5c&scoped=true&external"
import script from "./save-paper-info.js?vue&type=script&lang=js&external"
export * from "./save-paper-info.js?vue&type=script&lang=js&external"
import style0 from "./save-paper-info.scss?vue&type=style&index=0&id=80f43d5c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f43d5c",
  null
  
)

export default component.exports